import React from 'react';
import { RISK_LEVELS, RISK_LEVELS_LABELS } from '../../constants/riskLevels';

export default function RiskBadge({ level }) {
 const label = RISK_LEVELS_LABELS[level] || level;

 let colorClass = 'badge-neutral';
 if (level === RISK_LEVELS.LOW) colorClass = 'badge-success';
 else if (level === RISK_LEVELS.MEDIUM) colorClass = 'badge-warning';
 else if (level === RISK_LEVELS.HIGH) colorClass = 'badge-danger';
 else if (level === RISK_LEVELS.CRITICAL) colorClass = 'badge-danger';

 return (
 <span className={`badge ${colorClass}`}>
 {label}
 </span>
 );
}
